import React from "react";
import { Grid } from "components/Containers";
import AccountName from "./AccountName";
import AccountEmail from "./AccountEmail";

/**
 * AccountSettings
 *
 * Contents of the Account tab in personal settings.
 */
const AccountSettings = () => (
  <Grid>
    <Grid.col start={1} end={13}>
      <AccountName />
    </Grid.col>

    <Grid.col start={1} end={13}>
      <AccountEmail />
    </Grid.col>
  </Grid>
);

export default AccountSettings;
